import { authRoutes } from "./core/auth/routes";
import { onboardingRoutes } from "./core/Onboarding/routes";
import React from "react";
import withSuspense from "./components/wrappers/WithSuspense";
import { Navigate } from "react-router-dom";
import DevRenderConent from "./dev/Example";
import Premium from "./core/Payments/permiumBanner.page";
import PaymentSuccess from "./core/Payments/pages/paymentSuccess.page";
import Lesson from "./internal/courses/pages/Lesson/Lesson";
import Practice from "./internal/courses/pages/Practice";
import { courseRoutes } from "./core/Course/routes";
import { LeagueRoutes } from "./core/Leagues/routes";
import { learnRoutes } from "./core/Learn/routes";
import { profileRoutes } from "./core/Profile/routes";
import { internalRoutes } from "./internal/routes";
import Board from "./core/Module/sections/Board";
import Module from "./core/Module";
import Landing from "./core/landing";
const Dashboard = React.lazy(() => import("./core/Dashboard/index"));

const ResetPasswordPage = React.lazy(
  () => import("./core/auth/pages/ResetPassword.page")
);

export const defaultRoutes = [
  {
    path: "",
    element: <Landing />,
  },
  {
    path: "/dashboard",
    children: [
      {
        path: "",
        element: withSuspense(Dashboard),
        children: [
          {
            path: "learn",
            children: learnRoutes,
          },
          {
            path: "course",
            children: courseRoutes,
          },
          {
            path: "leagues",
            children: LeagueRoutes,
          },
          {
            path: "profile",
            children: profileRoutes,
          },
          {
            path: "internal",
            children: internalRoutes,
          },
          {
            path: "premium",
            element: <Premium />,
          },
        ],
      },
    ],
  },
  {
    path: "/auth/actions",
    element: withSuspense(ResetPasswordPage),
  },
  {
    path: "/premium",
    element: <Premium />,
  },
  {
    path: "/*",
    element: <Navigate to={"/dashboard/learn"} />,
  },
  {
    path: "/dev/xy-z",
    element: <DevRenderConent />,
  },
  {
    path: "/payment-success",
    element: withSuspense(PaymentSuccess),
  },
];

export const publicRoutes = [
  {
    path: "/onboarding",
    children: onboardingRoutes,
  },
  {
    path: "/auth",
    children: authRoutes,
  },
];

export const privateRoutes = [
  {
    path: "/:courseId/module",
    children: [
      {
        path: ":moduleId/:mode/board",
        element: withSuspense(Board),
      },
      {
        path: ":moduleId/:mode",
        element: withSuspense(Module),
      },
    ],
  },
  {
    path: "/course/:courseId/:moduleId/lesson",
    element: withSuspense(Lesson),
  },
  {
    path: "/course/:courseId/:moduleId/practice",
    element: withSuspense(Practice),
  },
];
